module.exports = "/_next/static/images/c0d2dd7bfdd8e14b3e63d6180b1e99d3-paperwork@mobile320.jpg";